/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/cross-plat-rust-vst-host-w-electron-gui.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/cross-plat-rust-vst-host-w-electron-gui.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/cross-plat-rust-vst-host-w-electron-gui.mdx';

const metadata = {
  slug: "cross-plat-rust-vst-host-w-electron-gui",
  title: "Cross-Platform Rust VST Host with Electron GUI",
  author: "Christian Battaglia",
  description: "Episode one of building a cross-platform, open source VST host in Rust — born from wanting to play my MIDI keyboard at 2am in NYC without waking the neighbors. Getting started with bindgen, WSL, and the joys of C++ compilation errors.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris-profile-hat.jpg",
  headerImage: "/assets-cdbattaglia/media/series/rust-vst-host/oscar-ivan-esquivel-arteaga-726701-unsplash-min.jpg",
  date: "2018-10-01T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["Rust","VST","audio","DSP","WSL","music technology","open source","bindgen","MIDI"],
};

export const Route = createFileRoute('/blog/posts/cross-plat-rust-vst-host-w-electron-gui')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/cross-plat-rust-vst-host-w-electron-gui',
    image: '/og/blog/cross-plat-rust-vst-host-w-electron-gui.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
